<template>
  <form @submit.prevent="onRegister" class="mb-3">
    <input v-model="name" class="form-control mb-2" placeholder="Nombre" required />
    <input v-model="email" class="form-control mb-2" placeholder="Email" required />
    <input v-model="password" class="form-control mb-2" type="password" placeholder="Contraseña" required />
    <select v-model="role" class="form-select mb-2">
      <option value="normal">Normal</option>
      <option value="superadmin">Superadmin</option>
    </select>
    <button class="btn btn-primary btn-sm w-100" type="submit">Agregar usuario</button>
    <span v-if="msg" style="color:green">{{ msg }}</span>
  </form>
</template>
<script>
import api from "../api/api";
export default {
  data() {
    return { name: "", email: "", password: "", role: "normal", msg: "" };
  },
  methods: {
    async onRegister() {
      await api.createUser({
        name: this.name,
        email: this.email,
        password: this.password,
        role: this.role,
      });
      this.msg = "Usuario agregado";
      this.name = this.email = this.password = "";
      this.$emit("userAdded");
    },
  },
};
</script>
